import Vue from 'vue';

const axios = Vue.prototype.$axios;

import {getDate} from '@/api/Select'
 
const v_url_base =  'xuper_auth/getBaseData'  

const v_url_dtl_save =  'xuper_auth/tableBodySave'  

const v_url_delete =  'xuper_auth/delTabRec'  
export default {

    /* =========================
     * 保存菜单流程定义
     * ========================= */
    saveMenuFlow(flowDefineId, nodes, edges) {

        
        if (!flowDefineId) {
            return Promise.reject(new Error('菜单流程定义保存失败'))
        }

        // 并发保存节点和连线
        return Promise.all([
            this.saveNodes(flowDefineId, nodes),
            this.saveEdges(flowDefineId, edges)
        ])
            .then(() => {
                return { success: true, message: '菜单流程保存成功' }
            })
            .catch(err => {
                console.error('保存菜单流程失败', err)
                return Promise.reject({ success: false, message: err.message || '菜单流程保存失败' })
            })
    },

    saveNodes(flowDefineId, nodes) {
        const promises = nodes.map((n, index) => {
            const props = n.properties || {}
            const refseqForm = props.formCode || props.moduleCode || flowDefineId
            const dbNode = {
                IDSEQ: flowDefineId,
                LSTSEQ: '', // 由数据库自动生成
                REFSEQ_FORM: refseqForm, // 表单主键（formCode）或模块主键（moduleCode）
                NODEID: n.id,
                NODENM: n.text instanceof Object ? n.text.value : n.text,
                NODE_X: n.x,
                NODE_Y: n.y,
                PROP: JSON.stringify(props),
                TEXT: JSON.stringify(n.text || {}),
                STFG: '0',
                SORTBY: index,
                LVL: '',
                RMK: '',
                ADDUSER: localStorage.getItem('v_usernm'),
                ADDDTTM: getDate('full'),
                UPDUSER: null,
                UPDDTTM: null
            }
            return axios.post(v_url_dtl_save, {
                p_table: 'BS_DEF_NODE',
                p_json: JSON.stringify(dbNode),
                p_idseq: '',
            })
        })
        return Promise.all(promises)
    },

    saveEdges(flowDefineId, edges) {
        const promises = edges.map((e, index) => {
            const dbEdge = {
                IDSEQ: flowDefineId,
                LSTSEQ: '',
                LINEID: e.id,
                LINETY: e.type.replace('flow:', ''),
                FRNODEID: e.sourceNodeId,
                TONODEID: e.targetNodeId,
                FRPOINT: JSON.stringify(e.startPoint || {}),
                TOPOINT: JSON.stringify(e.endPoint || {}),
                PROP: JSON.stringify(e.properties || {}),
                POINTLIST: JSON.stringify(e.pointsList || []),
                STFG: '0',
                TEXT: JSON.stringify(e.text || {}),
                RMK: '',
                ADDUSER: localStorage.getItem('v_usernm'),
                ADDDTTM: getDate('full'),
                UPDUSER: null,
                UPDDTTM: null
            }
            return axios.post(v_url_dtl_save, {
                p_table: 'BS_DEF_LINE',
                p_json: JSON.stringify(dbEdge),
                p_idseq: '',
            })
        })
        return Promise.all(promises)
    },

    /* =========================
     * 查询菜单流程数据
     * ========================= */
    async getMenuFlowData(flowDefineId) {
        const nodes = await this._getNodes(flowDefineId)
        const edges = await this._getEdges(flowDefineId)
        return this._assembleFlowData(nodes, edges)
    },

    async _getNodes(flowDefineId) {
        const res = await axios.post(v_url_base, {
            p_key: 'IDSEQ',
            p_value: flowDefineId,
            p_table: 'BS_DEF_NODE',
        })
        return res.result || []
    },

    async _getEdges(flowDefineId) {
        const res = await axios.post(v_url_base, {
            p_key: 'IDSEQ',
            p_value: flowDefineId,
            p_table: 'BS_DEF_LINE',
        })
        return res.result || []
    },

    /* =========================
     * 组装 LogicFlow 数据格式
     * ========================= */
    _assembleFlowData(nodes, edges) {
        // 构建节点映射，用于验证边的有效性
        const nodeIds = new Set(nodes.map(n => n.NODEID))
        
        return {
            nodes: nodes.map(n => ({
                id: n.NODEID,
                type: 'flow:menutask',
                x: Number(n.NODE_X) || 0,
                y: Number(n.NODE_Y) || 0,
                text: this._safeParseJSON(n.TEXT, n.NODENM || ''),
                properties: this._safeParseJSON(n.PROP, {})
            })),
            edges: edges
                .filter(e => {
                    // 过滤掉引用不存在节点的边
                    const valid = nodeIds.has(e.FRNODEID) && nodeIds.has(e.TONODEID)
                    if (!valid) {
                        console.warn(`[MenuFlow] 跳过无效边: ${e.LINEID}, 源节点: ${e.FRNODEID}, 目标节点: ${e.TONODEID}`)
                    }
                    return valid
                })
                .map(e => ({
                    id: e.LINEID,
                    type: 'flow:transition',
                    sourceNodeId: e.FRNODEID,
                    targetNodeId: e.TONODEID,
                    startPoint: this._safeParseJSON(e.FRPOINT, null),
                    endPoint: this._safeParseJSON(e.TOPOINT, null),
                    properties: this._safeParseJSON(e.PROP, {}),
                    pointsList: this._safeParseJSON(e.POINTLIST, []),
                    text: this._safeParseJSON(e.TEXT, {})
                }))
        }
    },
    
    _safeParseJSON(jsonStr, defaultValue) {
        if (!jsonStr) return defaultValue
        try {
            return JSON.parse(jsonStr)
        } catch (e) {
            console.warn('[MenuFlow] JSON解析失败:', jsonStr, e)
            return defaultValue
        }
    },

    /* =========================
     * 删除菜单流程定义
     * ========================= */
    delMenuFlow(flowDefineId) {
        return this.deleteEdges(flowDefineId)
            .then(() => this.deleteNodes(flowDefineId))
    },

    deleteNodes(flowDefineId) {
        return axios.post(v_url_delete, {
            p_key: 'IDSEQ',
            p_value: flowDefineId,
            p_table: 'BS_DEF_NODE'
        })
    },

    deleteEdges(flowDefineId) {
        return axios.post(v_url_delete, {
            p_key: 'IDSEQ',
            p_value: flowDefineId,
            p_table: 'BS_DEF_LINE'
        })
    }
}
